
import { Component, mixins } from '@niknevis/vue-modules'
import AdminTicketShowTabular from '@/modules/ticket/components/admin/AdminTicketShowTabular.vue'
import { ticketTabularColumn } from '@/modules/ticket/models/columns/ticket-show-tabular.column'

@Component
export default class TicketTabularHeader extends mixins(AdminTicketShowTabular) {

  protected columns = ticketTabularColumn()

  mounted() {
    this.columns = ticketTabularColumn()
  }
}
